export class Deposito {

    id:number;
    id_apostador:string;
    nome_apostador:string;
    telefone_apostador:string;
    status:string;
    codigo:string;
    valor: number;
    data: Date | string;
    erro: boolean;
    erroMensagem: string;
    imagemPix: string;
    textoPix: string;
    sitePix: string;
}
